import script from "./PopupEditInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopupEditInput.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPopupEdit,QInput});
